import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStore, RemoteConfigStore } from '@store';

import { combineLatest, filter, map, switchMap, tap } from 'rxjs';
import { FlutterHeatingSystemsHelper } from './flutter-heating-systems/flutter-heating-systems.helper';

export const flutterHeatingSystemsGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStore);
  const remoteConfigStore = inject(RemoteConfigStore);
  const router = inject(Router);

  return authStore.primaryVkorg$.pipe(
    filter((vkorg) => !!vkorg),
    switchMap(() =>
      combineLatest([
        remoteConfigStore.heatingSystemsAccess$,
        authStore.isUserWithHeatingSystemsOverviewRole$,
      ])
    ),
    map(([access, hasRole]) => {
      if (!access || !hasRole) {
        return false;
      }

      const url = state.url.substring(1);
      const systemIdRegex = new RegExp(`^${FlutterHeatingSystemsHelper.RouteNames.Systems}\/\\d+$`);

      if (url === FlutterHeatingSystemsHelper.RouteNames.Systems || systemIdRegex.test(url)) {
        return access.registeredInstallations;
      } else if (url === FlutterHeatingSystemsHelper.RouteNames.UnregisteredSerials) {
        return access.unregisteredSerials;
      } else if (url === FlutterHeatingSystemsHelper.RouteNames.WarrantyCodes) {
        return access.warrantyCodes;
      }
    }),
    tap((result) => {
      if (!result) {
        router.navigate(['/home']);
      }
    })
  );
};
